import {
  FETCH_ALL_QUOTES,
  FETCH_ONE_QUOTE,
} from '../constants/ActionTypes'

const INITIAL_STATE = { all_quotes: null, quote: null };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_ALL_QUOTES:
      return { ...state, all_quotes: action.payload };
    case FETCH_ONE_QUOTE:
      return { ...state, quote: action.payload };
    default:
      return state;
  }
}
